import type { WLatestRealizationsTranslations } from "./pl";

export const en: WLatestRealizationsTranslations = {
  readMore: "See",
  showAll: "All realizations",
  defaultTitle: "See other realizations",
};
